module.exports = __webpack_public_path__ + "prod/20260903163609/img/purpose.cda92bb6.png";